export const VocabDentistry = {
    'odontogram_history' : ['Historial', 'History'],
    'no_data' : ['Sin informacion a desplegar', 'No data to show'],
    'filter' : ['Filtro', 'Filter'],
    'filter_placeholder': ['Filtro', 'Filter'],
    'date': ['Fecha', 'Date'],
    'all_teeth': ['Todos', 'All'],

    'general_note' : ['Nota general', 'General note'],
    'mesial' : ['Mesial', 'Mesial'],
    'distal' : ['Distal', 'Distal'],
    'lingual' : ['Lingual', 'Lingual'],
    'vestibular' : ['Vestibular', 'Vestibular'],
    'palatine' : ['Palatino', 'Palatine'],
    'incisal' : ['Incisal', 'Incisal'],

    'oclusal' : ['Oclusal', 'Oclusal'],
    
    'tooth' : ['Diente', 'Tooth'],
    'root': ['Raíz', 'Root'],

    'selection': ['Selección', 'Selectection'],
    'selection_placeholder': ['Elementos seleccionados', 'Selected items'],

    'notes_placeholder': ['Introducir observaciones', 'Enter observations'],
    
    'right' : ['Derecha', 'Right'],
    'left' : ['Izquierda', 'Left'],
  }
    